export const ONBOARDING_STATUS_QUERY = "onboarding.status.v1";
/**
 * The live view behind the `onboarding.status.v1` seam
 * (`client/rpc/src/onboarding/onboarding-contract.ts`). `requiresDurableStorage: false`:
 * `OnboardingStatusService.status()` is an in-memory session check plus a home-node HTTP
 * round trip, never the OPFS-backed local SQLite cache, so this stays queryable before the
 * device is claimed/paired — the same rationale as `onboarding.discovery.v1`
 * (`./discovery.ts`) and `client-storage.state.v1` (#1661).
 */
export function createOnboardingStatusQuery(service) {
    return {
        invalidateOn: ["domain.entity-changed"],
        key: (row) => row.id,
        name: ONBOARDING_STATUS_QUERY,
        requiresDurableStorage: false,
        run: async (params) => {
            parseEmptyParams(params);
            return [await service.status()];
        },
    };
}
function parseEmptyParams(value) {
    if (value === null || typeof value !== "object" || Array.isArray(value) || Object.keys(value).length !== 0) {
        throw new TypeError("Onboarding status query does not accept parameters");
    }
}
//# sourceMappingURL=onboarding-status.js.map